/* src/app/home-new/mobile-home-summary/mobile-home-summary.component.scss */
#mobile-summary {
  border-radius: 20px 20px 0px 0px;
  box-shadow: 0px -4px 12px 0px rgba(0, 0, 0, 0.2);
  position: fixed;
  width: 100%;
  background: white;
  height: 255px;
  bottom: 70px;
  left: 0;
  right: 0;
  padding: 10px;
  z-index: 9998;
  transition: height 0.3s ease-in-out;
}
#mobile-summary.collapsed {
  height: 155px;
}
#collapsable-section {
  width: 100%;
}
#collapsable-section .header {
  height: 60px;
  background: #f6f6f6;
  border-radius: 15px 15px 0 0;
}
#collapsable-section .header.collapsed {
  border-radius: 15px 15px 15px 15px;
}
#collapsable-section .header-text {
  text-align: center;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
}
#collapsable-section .header-text ion-icon {
  font-size: 20px;
  vertical-align: middle;
}
#collapsable-section ion-button {
  margin: 0;
  height: 45px;
}
#collapsable-section ion-button::part(native) {
  padding-top: 0;
  padding-bottom: 0;
  margin: 0;
  min-height: 0;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
}
#collapsable-section ion-button ion-icon {
  margin-right: 10px;
}
#collapsable-section #collapsable-content {
  max-height: 200px;
  opacity: 1;
  overflow: hidden;
  transition:
    max-height 0.3s ease-in-out,
    opacity 0.4s ease,
    padding 0.3s ease;
  padding: 12px;
  background: #f6f6f6;
  border-radius: 0 0 15px 15px;
}
#collapsable-section #collapsable-content.filesAdded {
  border-radius: 0 15px 15px 15px;
}
#collapsable-section #collapsable-content.collapsed {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.groupPrice_label {
  color: #000;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 16px;
  font-weight: 400;
}
.groupPrice_price {
  color: #000;
  font-family: "League Spartan", sans-serif;
  font-size: 20px;
  font-weight: 600;
}
.totalPrice_label {
  color: #949494;
  text-align: right;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 16px;
  font-weight: 400;
}
.totalPrice_price {
  color: #949494;
  text-align: right;
  font-family: "League Spartan", sans-serif;
  font-size: 18px;
  font-weight: 600;
}
.disabled * {
  opacity: 60%;
}
.disabled * {
  pointer-events: none;
}
.slider-container {
  position: relative;
  width: 100%;
  height: 55px;
  max-width: 500px;
  margin: auto;
  display: flex;
}
.slider-track {
  position: absolute;
  width: 100%;
  height: 55px;
  border-radius: 200px;
  border: 1px solid #949494;
}
.slider-knob {
  position: absolute;
  width: 65px;
  height: 40px;
  background-color: black;
  border-radius: 100px;
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 5px;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
}
.slider-knob ion-icon {
  font-size: 40px;
}
.text-container {
  margin-left: 50px;
  flex-grow: 1;
}
.slider-text {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #949494;
}
#overlay-layer {
  height: 80%;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.56);
  position: absolute;
  border-radius: 200px;
}
.tooltip-icon {
  width: 20px;
  height: 20px;
  z-index: 99;
  cursor: pointer;
}
.shippingInfo {
  color: #0acf83;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 16px;
  font-weight: 600;
}
/*# sourceMappingURL=mobile-home-summary.component-QRX6KOIU.css.map */
